/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InstallmentPlanDocumentDto = {
    id?: string;
    originalName: string;
    storedName?: string;
    fileExtension?: string;
    objectKey?: string;
    installmentPlanId?: string;
    type: InstallmentPlanDocumentDto.type;
    downloadUrl?: string;
    uploadUrl?: string;
};
export namespace InstallmentPlanDocumentDto {
    export enum type {
        CITIZEN_ID_CARD = 'CITIZEN_ID_CARD',
        FACEBOOK_SCREEN = 'FACEBOOK_SCREEN',
        PHOTO_WITH_CARD = 'PHOTO_WITH_CARD',
        CONTRACT = 'CONTRACT',
        GENERATED_CONTRACT = 'GENERATED_CONTRACT',
        IMEI_OR_SERIAL = 'IMEI_OR_SERIAL',
        DEVICE_IMAGE = 'DEVICE_IMAGE',
        IMAGE_DOWN_PAYMENT = 'IMAGE_DOWN_PAYMENT',
        OTHERS = 'OTHERS',
        AUDIO = 'AUDIO',
        EVIDENCE_CONTRACT_1 = 'EVIDENCE_CONTRACT_1',
        EVIDENCE_CONTRACT_2 = 'EVIDENCE_CONTRACT_2',
        EVIDENCE_CONTRACT_3 = 'EVIDENCE_CONTRACT_3',
        EVIDENCE_CONTRACT_4 = 'EVIDENCE_CONTRACT_4',
        EVIDENCE_CONTRACT_5 = 'EVIDENCE_CONTRACT_5',
        EVIDENCE_CONTRACT_6 = 'EVIDENCE_CONTRACT_6',
        EVIDENCE_CONTRACT_7 = 'EVIDENCE_CONTRACT_7',
        EVIDENCE_CONTRACT_8 = 'EVIDENCE_CONTRACT_8',
        EVIDENCE_CONTRACT_9 = 'EVIDENCE_CONTRACT_9',
        EVIDENCE_CONTRACT_10 = 'EVIDENCE_CONTRACT_10',
        IMEI_SN_SCREEN = 'IMEI_SN_SCREEN',
        GENERAL_SETTINGS = 'GENERAL_SETTINGS',
        FACE_ID_TEST = 'FACE_ID_TEST',
        BOX_IMEI_SN = 'BOX_IMEI_SN',
        ACCESSORIES = 'ACCESSORIES',
    }
}

